import { authApi } from './auth.js';
import { createCoreClient } from './core.js';
import { demoApi } from './demo.js';
import { localsApi } from './locals.js';
import { membershipsApi } from './memberships.js';
/**
 * Cliente tipado de la API.
 *
 * Los módulos de la fase B NO se agregan acá: cada uno exporta su factory en su archivo
 * (`catalogApi(client)`, `pricesApi(client)`, …) y la app la usa con la instancia:
 *   `const catalog = catalogApi(api)`.
 */
export function createApiClient(options) {
    const core = createCoreClient(options);
    return {
        ...core,
        auth: authApi(core),
        locals: localsApi(core),
        memberships: membershipsApi(core),
        demo: demoApi(core),
    };
}
//# sourceMappingURL=client.js.map